window.addEventListener('load', () => {
    document.querySelectorAll('[data-qr-code-view]').forEach((q) => {
        q.addEventListener('click', (e) => {
            e.currentTarget.classList.toggle('active');
            e.stopPropagation();
            return false;
        })
    });
    window.addEventListener('click', () => {
        document.querySelectorAll('[data-qr-code-view]').forEach((q) => {
            q.classList.remove('active');
        });
    });
});
